// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD42ywGh60fAK86w8ctbrrrTIaNRaQSWNY',
    authDomain: 'mdeditor-90759.firebaseapp.com',
    projectId: 'mdeditor-90759',
    storageBucket: 'mdeditor-90759.appspot.com',
    messagingSenderId: '336067780510',
    appId: '1:336067780510:web:9630118b0c8292f636808f',
    measurementId: 'G-JTHPKTM74C',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
